import { render, staticRenderFns } from "./ShowRulerComponent.vue?vue&type=template&id=5b936eee&scoped=true"
import script from "./ShowRulerComponent.vue?vue&type=script&lang=js"
export * from "./ShowRulerComponent.vue?vue&type=script&lang=js"
import style0 from "./ShowRulerComponent.vue?vue&type=style&index=0&id=5b936eee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b936eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b936eee')) {
      api.createRecord('5b936eee', component.options)
    } else {
      api.reload('5b936eee', component.options)
    }
    module.hot.accept("./ShowRulerComponent.vue?vue&type=template&id=5b936eee&scoped=true", function () {
      api.rerender('5b936eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/ShowRulerComponent.vue"
export default component.exports